import React, { useState, useRef, useEffect } from 'react';
import topics from '../../../menus/LKG/Articles';
import { IonItem, IonLabel, IonRadio, IonRadioGroup } from '@ionic/react';

const Articles: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - LKG - English Language - Articles"; // Set page title
    }, []);

    return (
        <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};

export default Articles;